import { useInstantSearch } from 'react-instantsearch';
import { INSTANT_SEARCH_API_ERRORS } from './constants';

export default function useInstantSearchError() {
  const { error } = useInstantSearch();

  return (
    error &&
    INSTANT_SEARCH_API_ERRORS.find(
      (err) => err.instantSearchError === error.message
    )
  );
}
